import React from 'react';
import Hero from '../components/Hero';
import SafetyGuides from '../components/SafetyGuides';
import SitePartner from '../components/SitePartner';

const DrivingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <Hero 
        title="Driving Conditions" 
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773272098/Driving_c1vsow.png" 
      />
      <div className="max-w-6xl mx-auto px-4 mt-6">
        <SitePartner />
        <SafetyGuides delay={0.2} />
      </div>
    </div>
  );
};

export default DrivingPage;